module.exports = __webpack_public_path__ + "5894746ba37fdca427b2f611fd742b87.png";